var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"videoSkeleton"},[_c('skeleton-box',{staticClass:"videoSkeleton-video"}),(_vm.showControllers)?_c('skeleton-box',{staticClass:"videoSkeleton-controller"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }